// Client-side mirror of LeadOrders::DeliveryWindowRule (the order's Time of Day
// rule, #9965, also the agent's saved Default Time of Day, #15304):
// both-or-neither, start strictly before end ('HH:MM' compares lexically).
// Returns the message to show, or null when the pair is valid.
export function deliveryWindowError(start, end) {
  if (!start && !end) return null;
  if (!start || !end) return "Set both Time of Day times, or leave both blank for any time.";
  if (start >= end) return "The Time of Day start time must be before the end time.";
  return null;
}

// iOS Safari time inputs can emit HH:MM:SS — collapse to HH:MM so the lexical
// comparison and the posted value stay consistent.
export function timeInputValue(input) {
  return (input ? input.value : "").slice(0, 5);
}
